export class PollOptionsModel {
    option: string;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/poll-options.ts